"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Vimeo = /*#__PURE__*/function (_Component) {
  _inherits(Vimeo, _Component);

  _createClass(Vimeo, null, [{
    key: "thumbUrlFromResp",
    value: function thumbUrlFromResp(response, thumbWidth) {
      var height = response.height,
          width = response.width;
      var thumb = response.thumbnail_url_with_play_button;
      thumbWidth = thumbWidth || response.thumbnail_width;
      var thumbHeight = Math.ceil(thumbWidth * height / width);
      return thumb.replace(/_[0123456789]*x[0123456789]*./, "_".concat(thumbWidth, "x").concat(thumbHeight, "."));
    }
  }]);

  function Vimeo(props) {
    var _this;

    _classCallCheck(this, Vimeo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Vimeo).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "executeCommand", function (command) {
      return function () {
        if (!_this.frameReady) return;
        var vimeoCommand = JSON.stringify({
          method: command
        });

        _this.iframeRef.current.contentWindow.postMessage(vimeoCommand, 'https://player.vimeo.com');
      };
    });

    _this.state = {
      iframe: {}
    };
    var _this$props = _this.props,
        loop = _this$props.loop,
        autoplay = _this$props.autoplay,
        width = _this$props.width,
        height = _this$props.height,
        showTitle = _this$props.showTitle,
        url = _this$props.url;
    var params = "autoplay=".concat(autoplay, "&loop=").concat(loop, "&title=").concat(showTitle, "&width=").concat(width, "&height=").concat(height);
    var getUrl = "https://vimeo.com/api/oembed.json?url=".concat(url, "&").concat(params);
    _this.iframeRef = _react2["default"].createRef();
    fetch(getUrl).then(function (response) {
      return response.json();
    }).then(function (response) {
      var height = response.height,
          width = response.width,
          html = response.html,
          title = response.title;
      var thumbUrl = Vimeo.thumbUrlFromResp(response, props.thumbWidth);
      props.setThumb && props.setThumb(thumbUrl, title);
      var src = html.match(/src= *" *([^"]*) *"/)[1]; // Get url from response

      _this.setState({
        iframe: {
          divStyle: {
            padding: "".concat(100 * height / width, "% 0 0 0")
          },
          src: src
        }
      });
    });
    return _this;
  }

  _createClass(Vimeo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.iframeRef.current.onload = function () {
        return _this2.frameReady = true;
      };
    }
  }, {
    key: "render",
    value: function render() {
      var iframe = this.state.iframe;
      var _this$props2 = this.props,
          className = _this$props2.className,
          id = _this$props2.id;
      this.props.playing ? this.executeCommand('play')() : this.executeCommand('pause')();
      return _react2["default"].createElement("div", {
        style: iframe.divStyle,
        className: "relative ".concat(className)
      }, _react2["default"].createElement("iframe", {
        ref: this.iframeRef,
        title: id,
        className: "absolute top-0 left-0 w-100 h-100",
        src: iframe.src,
        frameBorder: "0",
        allowFullScreen: true,
        allow: "autoplay"
      }));
    }
  }]);

  return Vimeo;
}(_react.Component);

_defineProperty(Vimeo, "getThumbUrl", function (url, thumbWidth) {
  return new Promise(function (resolve, reject) {
    var getUrl = "https://vimeo.com/api/oembed.json?url=".concat(url);
    fetch(getUrl).then(function (response) {
      return response.json();
    }).then(function (response) {
      resolve(Vimeo.thumbUrlFromResp(response, thumbWidth));
    })["catch"](function () {
      return reject();
    });
  });
});

Vimeo.propTypes = {
  url: _propTypes2["default"].string.isRequired,
  id: _propTypes2["default"].number.isRequired,
  // Unique ID for iframe title
  setThumb: _propTypes2["default"].func,
  thumbWidth: _propTypes2["default"].number,
  className: _propTypes2["default"].string,
  loop: _propTypes2["default"].bool,
  autoplay: _propTypes2["default"].bool,
  showTitle: _propTypes2["default"].bool,
  width: _propTypes2["default"].number,
  height: _propTypes2["default"].number,
  playing: _propTypes2["default"].bool
};
Vimeo.defaultProps = {
  loop: true,
  autoplay: false,
  width: null,
  height: null,
  showTitle: false,
  className: ''
};
exports["default"] = Vimeo;